import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { ErrorModal } from '../components/ErrorModal';
export const LuxurySoftPlayPackages = () => {
  const {
    addToCart
  } = useCart();
  const navigate = useNavigate();
  const [addedItems, setAddedItems] = useState<Set<string>>(new Set());
  const [errorMessage, setErrorMessage] = useState<string>('');
  const handleAddToCart = (pkg: (typeof packages)[0]) => {
    // Try to add to cart
    const result = addToCart({
      type: 'softplay',
      packageName: pkg.name,
      packageValue: pkg.packageValue,
      price: pkg.price
    });
    if (result.success) {
      // Show success feedback briefly, then redirect to cart
      setAddedItems(prev => new Set(prev).add(pkg.packageValue));
      setErrorMessage('');
      // Redirect to cart after 800ms
      setTimeout(() => {
        navigate('/cart');
        window.scrollTo(0, 0);
      }, 800);
    } else {
      // Show error modal (no scroll)
      setErrorMessage(result.message || 'Unable to add item to cart');
    }
  };
  const packages = [{
    id: '01',
    name: 'Fancy Tot',
    packageValue: 'fancy-tot',
    image: 'https://cdn.magicpatterns.com/uploads/xfCKdqbKdcCaZYEumenuam/image.png',
    features: ['All customizations included (ball colors, animal colors, mat color, & vinyl decals)', 'Medium White Bounce House w/ Ball Pit (8ft W x 10ft L x 8ft H)', 'White Puzzle Mat Area (15x12)', '3 Bouncy Animals', 'White Ball Pit (clear & white)', 'Gym Climbing Blocks', 'Crawling Tunnel', 'Safety Gates'],
    price: '$475',
    originalPrice: '$500'
  }, {
    id: '02',
    name: 'Mega Fancy Tot',
    packageValue: 'mega-fancy-tot',
    image: 'https://cdn.magicpatterns.com/uploads/dGr2ftbUtvypHJz3RZrRmq/Screenshot_2026-06-23_at_10.51.26_PM.png',
    features: ['All customizations included (ball colors, animal colors, mat color, & vinyl decals)', 'White Combo Bounce House (13ft W x 15ft L x 10ft H)', 'White Puzzle Mats (18ft x 12ft or 15ft x 15ft)', '5 Bouncy Animals', 'White Ball Pit (clear & white)', 'Gym Climbing Blocks', 'Crawling Tunnel', 'Safety Gates', 'Rocking Horse', '"My First Roller Coaster"'],
    price: '$525',
    originalPrice: '$550'
  }];
  return <>
      <ErrorModal isOpen={!!errorMessage} message={errorMessage} onClose={() => setErrorMessage('')} data-id="element-785" />

      <div className="bg-white w-full" data-id="element-786">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-787">
          {/* Page Title Section */}
          <div className="text-center mb-16" data-id="element-788">
            <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-789">
              Luxury Soft Play Packages
            </h1>
            <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-790">
              Elegant white-themed soft play setups that add a sophisticated
              touch to any celebration.
            </p>
          </div>

          {/* Package Cards Section */}
          <div className="space-y-8" data-id="element-791">
            {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100" data-id="element-792">
                <div className="flex flex-col md:flex-row" data-id="element-793">
                  {/* Package Image */}
                  <div className="md:w-1/2 relative" data-id="element-794">
                    <img src={pkg.image} alt={`${pkg.name} Package`} className="w-full h-full object-cover" data-id="element-795" />
                  </div>

                  {/* Package Details */}
                  <div className="p-8 md:w-1/2" data-id="element-796">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-797">
                      <span className="text-primary-500" data-id="element-798">{pkg.id}</span> -{' '}
                      {pkg.name}
                    </h2>
                    <ul className="space-y-3 mb-8" data-id="element-799">
                      {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-800">
                          <CheckIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-801" />
                          <span data-id="element-802">{feature}</span>
                        </li>)}
                    </ul>
                    <div className="mt-auto text-center border-t border-gray-100 pt-6" data-id="element-803">
                      <div className="inline-flex items-center justify-center px-3 py-1 mb-3 bg-red-100 text-red-700 text-xs font-bold uppercase tracking-wide rounded-full" data-id="element-804">
                        ✨ Limited Time Deal
                      </div>
                      <div className="flex items-baseline justify-center gap-3 mb-4" data-id="element-805">
                        <span className="text-2xl font-medium text-gray-400 line-through" data-id="element-806">
                          {pkg.originalPrice}
                        </span>
                        <span className="text-4xl font-bold text-green-800" data-id="element-807">
                          {pkg.price}
                        </span>
                      </div>
                      <button onClick={() => handleAddToCart(pkg)} className={`inline-flex items-center px-6 py-3 rounded-md font-medium transition-all shadow-md ${addedItems.has(pkg.packageValue) ? 'bg-green-500 text-white' : 'bg-secondary-500 text-white hover:bg-secondary-600'}`} data-id="element-808">
                        {addedItems.has(pkg.packageValue) ? '✓ Added to Cart' : 'Add to Cart'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </>;
};